const START_VIDEO = (state, payload) => {
  state.selectedItem = {
    ...state.selectedItem,
    isStartingVideo: payload.isStartingVideo,
  };
};

export default START_VIDEO;
